export default __webpack_public_path__ + "static/media/Subtraction_00.488cdaf5.png";